import React from 'react';
import classNames from 'classnames';
import styles from '../assets/emails-log-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import textFilter from 'src/components/react-table/filters/text-filter';
import { IEmailLog } from 'src/types/email-log';
import EmailsLogActionsColumn from './EmailsLogActionsColumn';
import { QueryParams } from 'src/types/grid';
import { CellProps } from 'react-table';
import dateTimeFilter from 'src/components/react-table/filters/datetime-filter';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';

interface Props {
    data: Paginated<IEmailLog>;
    getData: (params: QueryParams) => void;
}
const columns: Column<IEmailLog>[] = [
    {
        Header: '#',
        accessor: 'id',
        width: '5%',
        disableFilters: true,
        disableSortBy: true,
        Filter: textFilter<IEmailLog>(),
    },
    {
        Header: 'Send To',
        accessor: 'receiver',
        Filter: textFilter<IEmailLog>(),
    },

    {
        Header: 'Subject',
        accessor: 'subject',
        Filter: textFilter<IEmailLog>(),
    },
    {
        Header: 'Sent At',
        accessor: 'lastSendAt[after]',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IEmailLog>) => changeToZeroMoment(original.lastSendAt, 'MMM D, YYYY'),
        Filter: dateTimeFilter<IEmailLog>(),
    },
    {
        Header: 'Sent By',
        accessor: 'sender',
        Filter: textFilter<IEmailLog>(),
    },
    {
        Header: 'Actions',
        accessor: 'template',
        Cell: EmailsLogActionsColumn,
        disableSortBy: true,
        disableFilters: true,
        width: '10%',
    },
];

const EmailsLogGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => (
    <div className={classNames(styles.grid)}>
        <Grid<IEmailLog> columns={columns} data={data} getData={getData} />
    </div>
);

export default EmailsLogGrid;
